/* eslint-disable no-console */

import {Button, Flex, Popover} from 'antd';
import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';

import {ReactComponent as ControlCenterIcon} from '../../../assets/ControlCenterIcon.svg';
import {drawerZIndex} from '../../../constants/Common';
import {PermissionEnum} from '../../../constants/permissionsEnum';
import {allRoutes, Routes, subRoutes} from '../../../constants/Routes';
import {checkIfHasPermissions} from '../../Menu/Utils/commonFunctions';

import ControlCenterLogos from './ControlCenterLogos';

const ControlCenterMenu: React.FC<{
  setProduct: React.Dispatch<React.SetStateAction<string>>;
  product: string;
  logoPlace?: React.CSSProperties;
}> = ({setProduct, product}) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [productsTiles, setProductTiles] = useState<any[]>([]);
  const products = [
    {
      title: 'Carbon Accounting',
      key: 'ca',
      icon: <ControlCenterLogos color={'#000000'} product="CA" />,
      hidden: !(
        checkIfHasPermissions(PermissionEnum.Dashboard) ||
        checkIfHasPermissions(PermissionEnum.OrgManager) ||
        checkIfHasPermissions(PermissionEnum.NZM) ||
        checkIfHasPermissions(PermissionEnum.AIDocumentManager)
      ),
      href: undefined,
      navigate: `${Routes.DASHBOARD}${subRoutes.metrics}`
    },
    {
      title: 'ESG Reporting',
      key: 'esg',
      icon: <ControlCenterLogos color={'#000000'} product="ESG" />,
      hidden: !checkIfHasPermissions(PermissionEnum.ESG),
      href: undefined,
      navigate: `${allRoutes.ESG.FRAMEWORK}`
    },
    {
      title: 'Net Zero Strategy',
      key: 'strategy',
      icon: <ControlCenterLogos color={'#000000'} product="Strategy" />,
      hidden: !checkIfHasPermissions(PermissionEnum.Strategy),
      href:
        process.env.REACT_APP_STRATEGY_URL ??
        'https://dev-strategy.bharatcarbon.earth',
      target: '_blank'
    }
  ];
  useEffect(() => {
    setProductTiles(products.filter((a) => !a.hidden));
  }, []);

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  return (
    productsTiles.length > 0 && (
      <Flex align="center" justify="center">
        <Button
          style={{
            backgroundColor: '#E1F3D9',
            height: '100%',
            padding: '6px',
            cursor: 'pointer',
            borderRadius: '0px',
            border: 'transparent'
          }}
        >
          <Flex align="center" gap={0}>
            <Popover
              placement="bottomLeft"
              arrow={false}
              trigger={['click']}
              open={open}
              style={{width: 'max-content !important'}}
              overlayClassName="productHover"
              onOpenChange={handleOpenChange}
              zIndex={drawerZIndex}
              content={
                <Flex
                  vertical={false}
                  align="flex-start"
                  justify="space-between"
                  className="productFlex"
                >
                  {productsTiles.map((item) => {
                    return (
                      <a
                        href={item?.href}
                        target={item?.target}
                        rel="noreferrer"
                        key={item.key}
                      >
                        <Flex
                          vertical={true}
                          align="center"
                          justify="center"
                          className={`singleProduct ${
                            product === item.key ? 'selected' : ''
                          }`}
                          style={{height: '5rem'}}
                          gap={5}
                          onClick={() => {
                            if (item?.key === 'strategy') {
                              setOpen(false);
                              setProduct('');
                            } else {
                              if (item.navigate) {
                                navigate(item.navigate);
                              }
                              setProduct(item.key);
                              localStorage.setItem('product', item?.key);
                              setOpen(false);
                            }
                          }}
                        >
                          {item.icon}
                          <div
                            style={{
                              fontSize: '10px',
                              textAlign: 'center',
                              fontWeight: 'bold',
                              lineHeight: '1rem',
                              textOverflow: 'ellipsis',
                              color: '#435B37'
                            }}
                          >
                            {item.title}
                          </div>
                        </Flex>
                      </a>
                    );
                  })}
                </Flex>
              }
            >
              <ControlCenterIcon />
            </Popover>
          </Flex>
        </Button>
      </Flex>
    )
  );
};

export default ControlCenterMenu;
